import {useEffect} from 'react';

export const useDiscardModalEffect = () => {
  const unloadCallback = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = ''; // Chrome対応
  };

  useEffect(() => {
    window.addEventListener('beforeunload', unloadCallback);
    return () => {
      window.removeEventListener('beforeunload', unloadCallback);
    };
  }, []);

  return null;
};
